<template>
  <div class="car-popular"
    :class="{'car-popular--mobile': deviceType === 'mobile'}">
    <div class="car-popular__container">
      <!-- 标题栏 -->
      <div class="car-popular__header">
        <h2 class="car-popular__title">Popular Cars</h2>
        <a v-if="!loading && cars.length > 0" class="car-popular__view-more" :href="getHrefForAll()">
          <span>View More</span>
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="10" viewBox="0 0 24 10"
            fill="none">
            <path
              d="M19.6112 10H16.3112C16.0733 10 15.9535 9.66313 16.1219 9.46625L19.9432 5L16.1214 0.533125C15.9529 0.336875 16.0727 0 16.3107 0H19.6106C19.8235 0 20.0272 0.0987495 20.178 0.274374L23.8432 4.55812C24.0523 4.8025 24.0523 5.19813 23.8432 5.44188L20.1785 9.725C20.0277 9.90125 19.824 10 19.6112 10ZM4.13548 9.725L7.80012 5.44188C8.00921 5.1975 8.00921 4.80187 7.80012 4.55812L4.13494 0.274374C3.98468 0.0987495 3.78094 0 3.56811 0H0.268158C0.0301937 0 -0.0895905 0.336875 0.078856 0.53375L3.90019 5L0.078856 9.46625C-0.0895905 9.66313 0.0296589 10 0.268158 10H3.56811C3.78094 10 3.98521 9.90125 4.13548 9.725ZM12.1567 9.725L15.8214 5.44188C16.0305 5.1975 16.0305 4.80187 15.8214 4.55812L12.1562 0.274374C12.0065 0.0987495 11.8022 0 11.5894 0H8.28942C8.05146 0 7.93167 0.336875 8.10012 0.53375L11.922 5L8.10065 9.46625C7.93221 9.66313 8.05146 10 8.28942 10H11.5894C11.8027 10 12.0065 9.90125 12.1567 9.725Z"
              fill="#e2372d" />
          </svg>
        </a>
        <div v-else class="car-popular__view-more-skeleton"></div>
      </div>

      <!-- 骨架屏 -->
      <div v-if="loading || cars.length === 0" class="car-popular__skeleton">
        <div class="car-popular__grid">
          <div v-for="n in 6" :key="`skeleton-${n}`" class="car-popular__card car-popular__card--skeleton">
            <div class="car-popular__card-img-wrapper">
              <div class="car-popular__skeleton-img"></div>
              <div class="car-popular__card-logo-circle car-popular__skeleton-logo"></div>
            </div>
            <div class="car-popular__card-info">
              <div class="car-popular__skeleton-title"></div>
              <div class="car-popular__skeleton-brand"></div>
            </div>
          </div>
        </div>
      </div>

      <!-- 实际内容 -->
      <div v-else class="car-popular__grid">
        <a v-for="(car, index) in cars" :key="index" class="car-popular__card"
          :href="getHrefForDetail(car)">
          <div class="car-popular__card-img-wrapper">
            <img :src="car.image" class="car-popular__card-img" :alt="car.model">
            <div class="car-popular__card-logo-circle">
              <img :src="car.logo" class="car-popular__card-logo" :alt="car.brand">
            </div>
          </div>
          <div class="car-popular__card-info">
            <h3 class="car-popular__card-title">{{ car.model }}</h3>
            <p class="car-popular__card-brand">{{ car.brand }}</p>
          </div>
        </a>
      </div>
      <AdComponent v-if="deviceType !== 'mobile' && $global.isValidAdConfig(adsensConfig?.home_4)"
        ref="ads-home-4-pc" class="ads-insert-full" :ads="adsensConfig?.home_4"
        :showDebug="showDebug" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import AdComponent from '@/pages/components/AdComponent.vue'

export default {
  name: 'CarPopular',
  components: {
    AdComponent
  },
  data () {
    return {
      cars: [],
      loading: true
    }
  },
  computed: {
    ...mapGetters(['deviceType', 'domainConfig', 'adsensConfig', 'showDebug'])
  },
  mounted () {
    this.fetchPopularCars();
  },
  methods: {
    async fetchPopularCars () {
      this.loading = true;
      try {
        const themeFilters = this.domainConfig?.themeFilters || {};
        const webIndex = this.domainConfig?.webIndex || 1;
        const params = { ...themeFilters, webIndex };
        const res = await this.$global.server.getRecommendedPopularCars(params);
        if (res.code === 200) {
          this.cars = (res.data || []).slice(0, 8).map(item => {
            const photos = item.photos ? item.photos.split(',') : [];
            return {
              id: item.id,
              model: item.name,
              brand: item.brand,
              logo: item.logoUrl,
              image: item.cover || photos[0]
            };
          });
        }
      } catch (error) {
        console.error('[CarPopular] fetch error:', error);
      } finally {
        this.loading = false;
      }
    },
    getHrefForAll () {
      const currentChannel = this.$route.params.channel;
      return currentChannel ? `/${currentChannel}/car-list` : '/car-list';
    },
    getHrefForDetail (car) {
      const currentChannel = this.$route.params.channel;
      const name = encodeURIComponent((car.model || '').replace(/\s+/g, '-'));
      return currentChannel ? `/${currentChannel}/cars/${name}/${car.id}` : `/cars/${name}/${car.id}`;
    }
  }
}
</script>

<style lang="scss">
@import '~@/css/variables.scss';

.car-popular {
	background: #000;
	padding: rem(60) rem(180);
	width: 100%;
	box-sizing: border-box;

	&__container {
		width: 100%;
	}

	&__header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: rem(30);
	}

	&__title {
		color: #ffffff;
		font-family: 'Inter-ExtraBold', sans-serif;
		font-size: rem(24);
		font-weight: 800;
		margin: 0;
	}

	&__view-more {
		display: flex;
		align-items: center;
		gap: rem(12);
		text-decoration: none;
		span {
			color: #e2372d;
			font-family: 'Inter-ExtraBold', sans-serif;
			font-size: rem(14);
			font-weight: 800;
		}
	}

	&__grid {
		display: grid;
		grid-template-columns: repeat(4, 1fr);
		gap: rem(20);
	}

	&__card {
		background: linear-gradient(180deg, rgba(226, 55, 45, 0) 0%, rgba(226, 55, 45, 0.2) 100%);
		border-radius: rem(16);
		border: 1px solid rgba(255, 255, 255, 0.1);
		overflow: hidden;
		text-decoration: none;
		transition: all 0.3s ease;
		display: flex;
		flex-direction: column;
		box-shadow: 0 rem(4) rem(12) rgba(0, 0, 0, 0.24);

		&:hover {
			transform: translateY(-5px);
			border-color: rgba(226, 55, 45, 0.5);
		}
	}

	&__card-img-wrapper {
		position: relative;
		height: rem(148);
		padding: rem(8);
	}

	&__card-img {
		width: 100%;
		height: 100%;
		object-fit: cover;
		border-radius: rem(12);
		border: 1px solid rgba(255, 255, 255, 0.1);
	}

	&__card-logo-circle {
		position: absolute;
		top: rem(9);
		left: rem(9);
		width: rem(32);
		height: rem(32);
		background: #fff;
		border-radius: rem(12) 0 rem(8) 0;
		display: flex;
		align-items: center;
		justify-content: center;
		padding: rem(4);
	}

	&__card-logo {
		width: 80%;
		height: 80%;
		object-fit: contain;
	}

	&__card-info {
		padding: rem(12) rem(16) rem(16);
		display: flex;
		align-items: center; /* 垂直居中 */
		gap: 20px; /* 固定间距 */
		width: 100%; /* 或者设定一个容器宽度，如 200px */
	}

	&__card-title {
		color: #ffffff;
		font-family: 'Inter-SemiBold', sans-serif;
		font-size: rem(14);
		font-weight: 600;
		margin: 0;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		margin: 0;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		flex: 1; /* 占据剩余空间，允许收缩 */
		min-width: 0; /* 防止 flex-shrink 失效 */
	}

	&__card-brand {
		color: rgba(255, 255, 255, 0.5);
		font-size: rem(12);
		margin: rem(4) 0 0;
		margin: 0;
		flex-shrink: 0; /* 禁止收缩，确保品牌始终完整显示 */
		white-space: nowrap; /* 防止品牌换行 */
	}

	// 骨架屏样式
	&__view-more-skeleton {
		width: rem(100);
		height: rem(24);
		background: rgba(255, 255, 255, 0.1);
		border-radius: rem(4);
		animation: skeleton-loading 1.5s ease-in-out infinite;
	}

	&__card--skeleton {
		pointer-events: none;
		cursor: default;
	}

	&__skeleton-img {
		width: 100%;
		height: 100%;
		background: rgba(255, 255, 255, 0.1);
		border-radius: rem(16);
		animation: skeleton-loading 1.5s ease-in-out infinite;
	}

	&__skeleton-logo {
		background: rgba(255, 255, 255, 0.1) !important;
		animation: skeleton-loading 1.5s ease-in-out infinite;
		img {
			display: none;
		}
	}

	&__skeleton-title {
		width: 70%;
		height: rem(18);
		background: rgba(255, 255, 255, 0.1);
		border-radius: rem(4);
		margin-bottom: rem(8);
		animation: skeleton-loading 1.5s ease-in-out infinite;
	}

	&__skeleton-brand {
		width: 50%;
		height: rem(14);
		background: rgba(255, 255, 255, 0.1);
		border-radius: rem(4);
		animation: skeleton-loading 1.5s ease-in-out infinite;
	}
}

@keyframes skeleton-loading {
	0% {
		opacity: 1;
	}
	50% {
		opacity: 0.4;
	}
	100% {
		opacity: 1;
	}
}

// PC端
.detect_deviece_pc,
.detect_deviece_desktop {
	.car-popular {
		padding: rem(60) rem(180);
		&__grid {
			grid-template-columns: repeat(4, 1fr);
		}
	}
}

// 移动端
.detect_deviece_mobile {
	.car-popular {
		padding: rem(60) 0 rem(60) rem(16);
		&__header {
			padding-right: rem(16);
		}
		&__grid {
			display: flex;
			overflow-x: auto;
			gap: rem(12);
			padding-right: rem(20);
			&::-webkit-scrollbar {
				display: none;
			}
		}
		&__card {
			min-width: rem(200);
			flex-shrink: 0;
		}
	}
}
</style>
